module.exports = __webpack_public_path__ + "static/renova.9d7227cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/renova.png
// module id = 402
// module chunks = 35783957827783